import {KilnConfiguration} from '@kilnfeature/types'

export const checkAreKilnDimensionsSetUp = (kilnConfiguration: KilnConfiguration) => {
  return (
    Number(kilnConfiguration.dimensions.diameter) > 0 &&
    Number(kilnConfiguration.dimensions.length) > 0
  )
}
